<template>
  <div class="compony">
    <!-- <p v-text="context"></p> -->
    <div class="compony-info" v-if="flag && contactInfoFlag">
      <div class="compony-name">
        {{ listData.company }}
      </div>
      <div class="compy-content">
        <div class="vip">
          <p>
            <label>会员类型 :</label
            ><span class="icon-vip"
              ><img :src="listData.gradeIcon" alt=""
            /></span>
          </p>
          <p>
            <label>会员年限 :</label><span>{{ listData.memberYears }}年</span>
          </p>
          <p v-if="listData.isSpotDeli">
            <label>现货认证 :</label><span class="isRenzheng">已认证</span>
          </p>
        </div>
        <div class="info">
          <p>
            <label>电话 : </label
            ><span class="tellphone">{{ listData.tel }}</span>
          </p>
          <p>
            <label>手机 : </label
            ><span class="phone">{{ listData.mobile }}</span>
          </p>
          <p>
            <label>联系人 : </label><span>{{ listData.contact }}</span>
          </p>
          <p>
            <label>邮箱 :</label><span>{{ listData.mail }}</span>
          </p>
          <p>
            <label>地址 :</label><span>{{ listData.addr }}</span>
          </p>
        </div>
        <!-- <button @click="getContext">查看简介</button> -->
        <div class="brand-total">
          <div class="brand">
            <p>品牌统计</p>
            <p>
              <i class="num">共{{ listData.brandCount }}条</i
              ><i class="time" v-if="listData.time"
                >({{ listData.time }}前更新)</i
              >
            </p>
          </div>
          <div id="main" style="width: 208px; height: 422px"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from 'axios'
import * as echarts from 'echarts'
import {
  onBeforeMount,
  onMounted,
  ref,
  defineProps,
  getCurrentInstance,
} from 'vue'
import emitter from '@/utils/emitter'
import { ElMessageBox } from 'element-plus'
var flag = ref(true)
var contactInfoFlag = ref(true)
const instance = getCurrentInstance()
const variable = ref('')

const changeUserInfo = emitter.on('openAdd', (data) => {

    if (data === undefined) {
        return flag.value = false

    } else {
        axios
            .get(
                "/api/TencentIM/GetModelByUserName?token=2&" + data
            )
            .then((res) => {
                if (res.data.successCode === 1) {
                    listData.value = res.data.resultData
                    getMyEacharts(res.data.resultData)
                }

            });
        return flag.value = true
    }

})
let listData = ref([]) //列表数据
const props = defineProps({
  allParams: { type: String, required: true },
})
const internalData = instance?.appContext.config.globalProperties
// let count = ref(0)
const MPuserName = internalData?.$cookies.get('MPuserName')
// console.log(MPuserName, 'MPuserName：');
const index = props.allParams?.indexOf('&username')
// const str=props.allParams.substring(0,index)
const strall = props.allParams?.substring(index)
let clientip = JSON.parse(localStorage.getItem('clientip') || '[]')
const hasBaidu = function () {
  const url = window.location.href
  let allParams = url?.split('?')[1]
  let params = new URLSearchParams(allParams)
  let tracksource = params.get('tracksource')
  console.log(tracksource?.toLowerCase(), 'tracksource.lower()')
  if (tracksource?.toLowerCase() == 'baidu') {
    console.log('包含子字符串')
    return (contactInfoFlag.value = false)
  }
}
async function GetData() {
  // 公网ip http://ipinfo.io/json https://api.ipify.org
  let data
  await axios
    .get('https://ipinfo.io/json')
    .then((res) => {
      data = res.data.ip || ''
      localStorage.setItem('clientip', JSON.stringify(data) || '')
    })
    .catch((err) => {
      console.log(err)
    })

  return data
}


const getContext = function () {
  let userurl =
    '/api/TencentIM/GetModelByUserName?token=2&' +
    props.allParams +
    '&ip=' +
    clientip

  axios
    .get(userurl)
    .then((res) => {
      emitter.emit('limitSend', res.data.successCode)
      if (res.data.successCode) {
        listData.value = res.data.resultData
        getMyEacharts(res.data.resultData)
        // console.log("成功");
        return (flag.value = true)
      } else {
        ElMessageBox.alert('访问次数超过限制', {
          callback: () => {
            location.href = 'https://www.dzsc.com/'
            //window.open('https://www.dzsc.com/')
          },
        })
        return (flag.value = false)
      }
    })
    .catch((err) => {
      // console.log(err, "失败");
      return (flag.value = false)
    })
}
const getMyEacharts = function (obj) {
  if (obj === '' || obj === undefined) return
  var myChart = echarts.init(document.getElementById('main'))
  let brandData = JSON.parse(obj.brandData).splice(0, 10)
  let brandDataList = JSON.parse(obj.brandDataList).splice(0, 10)
  // var brandData = ["SEMIKRON", "IXYS", "Infineon", "SANREX", "英飞凌"];
  // var brandDataList = [{ "name": "SEMIKRON", "value": 403 }, { "name": "IXYS", "value": 325 }, { "name": "Infineon", "value": 254 }, { "name": "SANREX", "value": 12 }, { "name": "英飞凌", "value": 6 }];
  var option = {
    legend: {
      type: 'scroll',
      orient: 'vertical',
      top: '45%',
      left: '0%',

      align: 'left',
      data: brandData,
      itemGap: 8,
      textStyle: {
        fontSize: '12',
        color: 'rgba(51,51,51,0.45)',
      },
      itemStyle: {
        margin: '5%',
      },
      itemWidth: 24, //图例图形的宽度
      itemHeight: 12,
      selectedMode: false,
      // formatter: function (name) {
      //     return name.length > 10 ? name.substr(0, 10) + "..." : name;
      // }
      formatter: function (name) {
        var data = option.series[0].data
        var total = 0
        var tarValue
        for (var i = 0; i < data.length; i++) {
          total += data[i].value
          if (data[i].name == name) {
            tarValue = data[i].value
          }
        }
        var v = tarValue //单条
        var p = ((tarValue / total) * 100).toFixed(2)
        return `${name} ${v}条 (${p}%)`
      },
    },
    color: ['#01add7', '#7ec297', '#dcbd4e', '#8b85d8', '#eb673c', '#ababab'],
    series: [
      {
        name: '访问来源',
        type: 'pie',
        radius: ['50%', '80%'],
        center: ['50%', '22%'],
        avoidLabelOverlap: false,
        label: {
          normal: {
            show: false,
            position: 'center',
            textStyle: {
              fontSize: '12',
            },
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: '12',
            },
            formatter: '{b}\n({d}%)',
            lineHeight: 14,
          },
        },
        labelLine: {
          normal: {
            show: false,
          },
        },
        data: brandDataList,
      },
    ],
  }
  function emphasis() {
    var dataLen = option.series[0].data.length
    // 高亮当前图形
    myChart.dispatchAction({
      type: 'highlight',
      seriesIndex: 0,
      dataIndex: 0,
    })
  }
  function unemphasis() {
    var dataLen = option.series[0].data.length
    // 取消之前高亮的图形
    myChart.dispatchAction({
      type: 'downplay',
      seriesIndex: 0,
      dataIndex: 0,
    })
  }
  myChart.setOption(option)
  emphasis()
  myChart.on('mouseover', function (a) {
    if (a.dataIndex != 0) {
      unemphasis()
    }
  })
  myChart.on('mouseout', function () {
    emphasis()
  })
}
onBeforeMount(() => {
  emitter.on('componyShow', (res) => {
    variable.value = res.value
    // console.log(variable.value, 'variable.value')
  })
})
onMounted(() => {
  getMyEacharts()
  getContext()
  hasBaidu()
  GetData()
})
</script>

<style lang="scss" scoped>
.compony {
  // height: 84vh;
  .top {
    box-sizing: border-box;
    width: 238px;
    height: 54px;
    background: #ffffff;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  }
  .compony-info {
    width: 238px;
    height: 100%;
    padding: 0 0 0 12px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
    border-left: 1px solid #e0e0e0;
    label {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 0.85);
      line-height: 16px;
      text-align: right;
      display: inline-block;
    }
    p {
      margin-bottom: 8px;
    }
    & > div {
      border-bottom: 1px dashed #ccc;
      margin-bottom: 16px;
      padding-bottom: 8px;
    }
    & > div:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
    .compony-name {
      width: 94%;
      text-align: left;
      padding: 18px 0;
      box-sizing: border-box;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      font-family: PingFang SC-Medium, PingFang SC;
    }
    .compy-content {
      height: 728px;
      overflow-x: hidden;
      overflow-y: auto;
    }
    ::-webkit-scrollbar {
      width: 6px;
      height: 108px;
      background-color: transparent;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #9a999c;
    }
    .vip {
      span {
        width: 130px;
        display: inline-block;
      }
      label {
        width: 64px;
        margin-right: 4px;
      }
      .isRenzheng {
        color: rgba(77, 181, 10, 0.85);
      }
      .icon-vip img {
        max-width: 101px;
        max-height: 20px;
        margin-right: 3px;
      }
    }
    .info {
      span {
        width: 150px;
        display: inline-block;
        word-wrap: break-word;
        word-break: break-all;
      }
      .tellphone {
        display: inline-block;
        max-width: 118px;

        color: #eb000e;
      }
      .phone {
        display: inline-block;
        max-width: 98px;
      }
      label {
        width: 54px;
        margin-right: 4px;
        float: left;
      }
    }
    .brand-total {
      .brand {
        width: 100%;
        height: 20px;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 16px;

        i {
          font-style: normal;
          font-size: 12px;
          font-weight: 500;
          line-height: 14px;
        }
        p {
          float: left;
        }
        .num {
          color: rgba(51, 51, 51, 0.65);
          margin-left: 8px;
        }
        .time {
          color: #57ab57;
        }
      }
    }
  }
}
</style>
